// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "calendar_account".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "calendar_account" table (1:1 with a DB row, on the wire). */
export const calendarAccountAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    email: z.string(),
    displayName: z.string().nullable(),
    calendarId: z.string(),
    isActive: z.boolean(),
    syncEnabled: z.boolean(),
    purpose: z.enum(['sync', 'meet_only']),
    syncScope: z.enum(['organization', 'personal']),
    encryptedCredentials: z.string(),
    lastSyncAt: z.string().datetime().nullable(),
    tokenExpiresAt: z.string().datetime().nullable(),
    watchChannelId: z.string().nullable(),
    watchResourceId: z.string().nullable(),
    watchExpiration: z.string().datetime().nullable(),
    syncToken: z.string().nullable(),
    fullSyncInitialized: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=calendarAccount.js.map